import React from "react";
import PropTypes from "prop-types";
import { Field } from "formik";

const FormikCheckbox = ({ name, label, disabled }) => (
  <span>
    <label
      style={{
        alignItems: "center",
        cursor: disabled ? "default" : "pointer",
        justifyContent: "center",
        fontSize: "1.15em",
        display: "inline-flex",
        paddingRight: 20
      }}
    >
      {label}
      <Field
        type="checkbox"
        name={name}
        disabled={disabled}
        style={{ margin: "0px 10px" }}
      />
    </label>
  </span>
);

FormikCheckbox.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  disabled: PropTypes.bool
};

export default FormikCheckbox;
